import { TextFieldProps } from './TextField';
import { Theme, css } from '@emotion/react';

export const textFieldStyles =
  ({ valid, warn, disabled, qualifier }: TextFieldProps) =>
  ({ typography, spacing, colors }: Theme) => css`
    &.MuiFormControl-root {
      position: initial;
      gap: ${spacing(0.5)}px;
    }
    & .MuiFormLabel-root.MuiInputLabel-root.MuiInputLabel-formControl {
      position: initial;
      transform: none;
      ${typography.variant('captionStrong')};
      color: ${disabled ? colors.fgDisabled : colors.fgDefault};
    }
    & .MuiOutlinedInput-notchedOutline {
      top: 0;
      border: 1px solid ${colors.borderDefault};
    }
    & .MuiOutlinedInput-notchedOutline legend {
      display: none;
    }
    & .MuiInputBase-root {
      ${disabled &&
      `
		background: ${colors.bgLighter};
	  `}
    }

    & .MuiInputBase-input {
      height: auto;
      padding: ${spacing(1.5)}px;
      ${typography.variant('body')};
      line-height: 20px;
    }
    // NOTE: MUI sets these fields with the !important flag which needs to be overwritten with the !important flag here
    @layer {
      .MuiInputBase-input::placeholder {
        opacity: 1 !important;
        ${typography.variant('body')};
        color: ${colors.fgSubtle} !important;
        ${disabled && `color: ${colors.fgDisabled} !important;`}
      }
    }
    & .MuiOutlinedInput-multiline {
      padding: ${spacing(1.5)}px;
    }
    & .MuiOutlinedInput-inputMultiline {
      padding: 0;
    }
    & .MuiFormHelperText-contained {
      margin-left: ${spacing(0.5)}px;
    }
    & .MuiInputAdornment-root > p,
    .MuiInputAdornment-root > svg {
      ${disabled && `color: ${colors.fgDisabled};`}
    }
    & .MuiFormHelperText-root.MuiFormHelperText-contained {
      margin: 0;
      ${disabled && `color: ${colors.fgDisabled};`}
      ${typography.variant('caption')}
      ${warn &&
      `
		  color: ${colors.fgWarningBase};
	  `}
        ${valid &&
      `
		  color: ${colors.fgSuccessBase};
	  `};
    }
    & .MuiFormLabel-asterisk {
      margin-left: ${spacing(0.25)}px;
      color: ${colors.fgDangerBase};
      ${disabled && `display: none`}
    }
    ${qualifier === 'optional' &&
    `
      & .MuiInputLabel-root::after {
        ${disabled && `display: none`};
        margin-left: ${spacing(0.25)}px;
        color: ${colors.fgSubtle};
        content: '(optional)';
        visibility: visible;
      }
    `}
  `;

export const textFieldWithSelectRoot = css`
  & .MuiOutlinedInput-adornedStart {
    padding-left: 0;
  }
`;

export const textFieldSelectInput = css`
  &:after,
  &:before,
  &:hover,
  & fieldset {
    /* This is marked important due to the specificity level of MUI */
    border-width: 0 !important;
  }

  & svg {
    top: 50%;
    transform: translateY(-50%);
  }
`;
